import { Button } from "@mui/material";
import Link from "next/link";
import PlusIcon from "./icons/PlusIcon";

export default function CreateNewEntry({ createLocationUrl }) {
  return (
    <Button
      component={Link}
      href={createLocationUrl}
      variant="contained"
      color="secondary"
      fullWidth
      startIcon={<PlusIcon />}
    >
      Eintrag hinzufügen
    </Button>
  );
}
